<template>
  <g v-if="color && precoloredSrc">
    <image width="800" height="1000" :xlink:href="precoloredSrc"></image>
  </g>
</template>

<script>
import { mapGetters } from "vuex";
import CONSTANTS from "@/constants.js";

export default {
  name: "PrecoloredSVGGroup",
  props: {
    product: {
      type: Object,
    },
    design: {
      type: Object,
    },
    groupIndex: {
      type: Number,
    },
    side: {
      type: String
    }
  },
  computed: {
    ...mapGetters("playbook", ["color1", "color2", "color3"]),

    precoloredSrc() {
      const styleId = this.product.style_id,
        designName = this.design.name.toLowerCase(),
        colorName = this.mappedFlashColorName;

      return `${CONSTANTS.FLASH_BUILDER_S3_BUCKET}${styleId}/${this.side}/${designName}_c${this.groupIndex}_${colorName}.png`;
    },

    mappedFlashColorName() {
      const colorName = this.color.name.toLowerCase().replaceAll(" ", "-");
      switch (colorName) {
        case "texas": {
          return "texas-orange";
        }
        case "columbia": {
          return "columbia-blue";
        }
        case "royal": {
          return "royal-blue";
        }
        default: {
          return colorName;
        }
      }
    },

    color() {
      return this[`color${this.groupIndex}`];
    },
  },
};
</script>